module.exports = __webpack_public_path__ + "img/logo.06c764b5.svg";